// Diagnostic-only module. Captures persister-restore lifecycle events from
// PersistQueryClientProvider so an on-screen debug overlay (or Sentry trace)
// can reason about offline cold-boot timing. Intentionally trivial — not
// imported by production code paths beyond `main.tsx`.

interface PersisterDebugState {
  bootAt: number;
  restoredAt: number | null;
  restoreErrorPhase: string | null;
  restoreErrorMessage: string | null;
}

const state: PersisterDebugState = {
  bootAt: Date.now(),
  restoredAt: null,
  restoreErrorPhase: null,
  restoreErrorMessage: null,
};

export function markRestoreSuccess(): void {
  state.restoredAt = Date.now();
}

export function markRestoreError(phase: string, err: unknown): void {
  state.restoreErrorPhase = phase;
  state.restoreErrorMessage = err instanceof Error ? err.message : String(err);
}

export function getPersisterDebugState(): Readonly<PersisterDebugState> {
  return state;
}
